import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.66 9.195c-.211-.124-.51-.21-.828-.075-.475.202-1.491.533-1.94.674l-.8-.795c.655-1.268 2.333-3.883 3.806-4.19.818-.172 1.347-.022 1.671.214.372-.429.81-.897 1.323-1.407 3.91-3.885 6.788-2.304 6.788-2.304s1.439 2.709-2.425 6.64c-.51.505-.977.937-1.405 1.304.297.302.524.858.327 1.79-.31 1.465-2.941 3.132-4.218 3.782l-.8-.795c.141-.445.475-1.455.679-1.927.147-.341.033-.66-.107-.871-.027-.011-.04-.02-.04-.02L4.66 9.195Zm5.11-3.258a1.37 1.37 0 0 0 1.93 0 1.35 1.35 0 0 0 0-1.917 1.37 1.37 0 0 0-1.93 0 1.35 1.35 0 0 0 0 1.917Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.563 13.918c-.71.705-3.563.987-3.563.987s.283-2.836.993-3.541a1.826 1.826 0 0 1 2.57 0c.71.705.71 1.849 0 2.554Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconProductVasPremium16 = createIcon(IconComponent);